"use strict";
/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousBatchClient
 * @description  Notifications Subscriptions Anonymous Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsAnonymousBatchClient` uses `notificationsSubscriptionsAnonymousBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require("./");
var NotificationsSubscriptionsAnonymousBatchClient = /** @class */ (function () {
    function NotificationsSubscriptionsAnonymousBatchClient(notificationsSubscriptionsAnonymousBatchRoute, apiClient) {
        this.notificationsSubscriptionsAnonymousBatchRoute = notificationsSubscriptionsAnonymousBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous subscription action has been performed; this action creates new anonymous subscription resources.
     * @method
     * @param data AnonymousSubscription objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous subscription action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.create([{
                    channel: '<channel-name>',
                    registrationId: '<registration-id>' ž
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove anonymous subscription resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify AnonymousSubscription resources that need to be deleted.
     * @returns a promise that is resolved once the remove action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.remove(subscriptionIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsSubscriptionsAnonymousBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update anonymous subscriptions action has been performed; this action updates specified anonymous subscription resources.
     * @method
     * @param data AnonymousSubscription objects used to update specified AnonymousSubscription resources.
     * @returns A promise that is resolved once the update anonymous subscriptions action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.update(subscriptions)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSubscriptionsAnonymousBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousBatchRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSubscriptionsAnonymousBatchClient);
    return NotificationsSubscriptionsAnonymousBatchClient;
}());
exports.NotificationsSubscriptionsAnonymousBatchClient = NotificationsSubscriptionsAnonymousBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
